module.exports = __webpack_public_path__ + "img/live-drop-500151533291eeff620a49cf6af2bab2.f18464b1.png";